import React from 'react';
import {Popover, OverlayTrigger, Button, FormControl, InputGroup, FormGroup, Glyphicon} from 'react-bootstrap';
import CopyToClipboard from 'react-copy-to-clipboard';
import FontAwesome from 'react-fontawesome';

class RSSfeed extends React.Component {
  constructor(props) {
    super(props);
    this.onCopy = this.onCopy.bind(this);
    this.onChange = this.onChange.bind(this);
    this.state = {
      value: props.feedURI || ''
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      value: nextProps.feedURI,
      copied: false
    });
  }


  onChange({target: {value}}) {
    this.setState({value, copied: false});
  }

  onCopy() {
    this.setState({copied: true});
  }


  render() {
    const popover = (
      <Popover id="popover-rss" title="RSS feed">
        <FormGroup>
          <InputGroup>
            <FormControl
              type="text"
              value={this.state.value}
              onChange={this.onChange}
            />
            <CopyToClipboard text={this.state.value} onCopy={this.onCopy}>
              <InputGroup.Button>
                <Button bsStyle="secundary"><Glyphicon glyph="glyphicon glyphicon-duplicate"/></Button>
              </InputGroup.Button>
            </CopyToClipboard>
          </InputGroup>
        </FormGroup>

      </Popover>
    );
    return (
      <OverlayTrigger placement="top" trigger="click" rootClose overlay={popover}>
        <Button className="btn-sm btn-rss"><FontAwesome name="rss"/>&nbsp;&nbsp;RSS</Button>
      </OverlayTrigger>
    );
  }
}

RSSfeed.propTypes = {
  feedURI: React.PropTypes.string.isRequired
};

export default RSSfeed;



/** WEBPACK FOOTER **
 ** ./src/modules/home/components/RSSfeed.js
 **/